import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const useConfirm =
  ({ message, title }) =>
  () =>
    new Promise((resolve) => {
      confirmAlert({
        title,
        message,
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              resolve(true);
            },
            className: 'confirm__btn confirm__btn__primary',
          },
          {
            label: 'No',
            onClick: () => {
              resolve(false);
            },
            className: 'confirm__btn',
          },
        ],
        onClickOutside: () => {
          resolve(false);
        },
        onKeypressEscape: () => {
          resolve(false);
        },
      });
    });

export default useConfirm;
